module.exports = __webpack_public_path__ + "static/Awasul_banner_2-b75d32815aa34ecaef83cdaa8ae89d44.png";